import { useContext, useEffect, useState } from "react";
import Button from "./Button";
import GreenDot from "./GreenDot";
import Modal from "src/components/Modal";
import ModalHeader from "src/components/Modal/ModalHeader";
import ModalBody from "src/components/Modal/ModalBody";
import ModalFooter from "src/components/Modal/ModalFooter";
import { defaultHeaderHeight } from "src/settings/config";
import userContext from "src/context/userContext";

export default function AvatarButton({ direction }) {
    const [active, setActive] = useState(false);
    const { user } = useContext(userContext)

    const handleLogout = () => {
        localStorage.removeItem("access_token");
        window.location.href = "/";
    }
    return (
        <div className="relative">
            <Button isActive={active} toggle={() => setActive(true)} />
            <Modal
                isOpen={active}
                toggle={setActive}
                top={defaultHeaderHeight}
                width={300}
                left={direction == "rtl" && 10}
                right={direction != "rtl" && 10}
            >
                <ModalBody>
                    <div className="flex flex-col p-4 space-y-1 font-medium border-b">
                        <div className="text-gray-800 flex items-center gap-1">
                            <span>
                                {user?.fullName}
                            </span>
                            <span className="text-sm text-gray-400 font-light">
                                ({user?.role?.roleTranslate})
                            </span>
                        </div>
                        <span className="text-sm text-gray-400">
                            {user?.email}
                        </span>
                    </div>

                    <div
                        className="cursor-pointer mt-4 flex items-center justify-center p-3 text-red-600 bg-red-50 rounded-lg"
                        onClick={handleLogout}
                    >
                        <span>خروج</span>
                    </div>
                </ModalBody>
            </Modal>
        </div>
    )
}